import { render, staticRenderFns } from "./type1.vue?vue&type=template&id=d0cd6de0&scoped=true&"
import script from "./type1.vue?vue&type=script&lang=js&"
export * from "./type1.vue?vue&type=script&lang=js&"
import style0 from "./type1.vue?vue&type=style&index=0&id=d0cd6de0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0cd6de0",
  null
  
)

export default component.exports